import SEO from "@/components/SEO";

export default function About() {
  return (
    <>
      <SEO pageKey="about" title="About — SerpNex" description="SerpNex is a focused keyword rank tracker for anyone who needs one — agencies, freelancers, in-house marketers, bloggers, and small business owners. Simple, transparent, honest." canonical="/about" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24">
        <div className="eyebrow">About</div>
        <h1 className="mt-3 h-display text-5xl sm:text-6xl font-bold text-[#0A0D14]">A rank tracker with a spine.</h1>

        <div className="mt-10 space-y-6 text-[17px] leading-relaxed text-[#525B6A]">
          <p>SerpNex started with a frustrated team and one honest observation: most SEO tools are built to look impressive in a sales demo — not to be used on a Tuesday morning by an agency SEO, a freelancer between clients, or a blogger tracking five keywords over morning coffee.</p>
          <p>So we deleted the modules nobody uses. No backlink audit tab. No AI writer. No content optimizer with a made-up score. What&apos;s left is a keyword tracker that tells you three things every morning: what moved, why, and what to do next. Whether you have 5 keywords or 5,000.</p>
          <p>We update daily. We show timestamps everywhere. When a refresh is delayed, we say so — instead of hiding behind a stale number. Everyone gets burned enough by tools that pretend to be certain when they aren&apos;t.</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-3 gap-6">
          {[
            { t: "Transparency first", b: "If the data isn't fresh, we tell you. Every screen has a last-updated timestamp." },
            { t: "Narrow on purpose", b: "We only build features that make daily rank-tracking better. Everything else is a distraction." },
            { t: "Simple and scalable", b: "Simple enough for a solo blogger's 5 keywords. Strong enough for an agency's 5,000." },
          ].map((v, i) => (
            <div key={i} className="card-crisp p-5">
              <div className="text-lg font-display font-semibold text-[#0A0D14]">{v.t}</div>
              <div className="mt-2 text-sm text-[#525B6A] leading-relaxed">{v.b}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
